import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { DeleteSubObjectives } from "../../../Redux/Reducers/ReportStage/SubObjectives";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import AddEditSubObjective from "../SubObjectives/AddEditSubObjective";
import { useNavigate, useParams } from "react-router-dom";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TransferRequestDetailsForm from "./TransferRequestDetailsForm";
import JustificationsforTransfer from "./JustificationsforTransfer";
import JustificationsforTransferForm from "./JustificationsforTransferForm";
import "./style.css";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import {
  ChangeStatusByUser,
  GetProjectModificationRequestsById,
  ProcedureForTransferRequest,
} from "../../../Redux/Reducers/ReportStage/ProjectModificationRequests";
import { DeleteTransferRequestDetails } from "../../../Redux/Reducers/ReportStage/TransferRequestDetails";
import { HandelRoleTransfer } from "../../../Redux/Reducers/ReportStage/TransferRole";
const TransferRequestDetails = (props) => {
  const HandelRoleTransferResult = useSelector(
    (state) => state.TransferRoleReducer.TransferRole
  );
  const navigator = useNavigate();
  const ProjectModificationRequests = useSelector(
    (state) => state.ProjectModificationRequests.ProjectModificationRequests
  );
  const { reportId, projectModificationRequestsId } = useParams();
  let location = window.location.pathname.split("/").includes("report");

  const userInfo = useSelector((state) => state.UserInfo.UserInfo);

  const [
    justificationsforTransferBeneficiary,
    setJustificationsforTransferBeneficiary,
  ] = useState(null);
  const [
    justificationsForTransferEmployee,
    setJustificationsForTransferEmployee,
  ] = useState(null);
  const [File, setFile] = useState(null);

  const [jsonData, setJsonData] = useState({});
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [subObjectivesId, setsubObjectivesId] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const AddTransferRequestDetails = useSelector(
    (state) => state.TransferRequestDetails.AddTransferRequestDetails
  );
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "itemNameFrom",
      ShowStatus: true,
      NmaeColumn: "البند المراد النقل منه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemNameTo",
      ShowStatus: true,
      NmaeColumn: "البند المراد النقل اليه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "requestedAmount",
      ShowStatus: true,
      NmaeColumn: "القيمة المطلوبة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        setsubObjectivesId(e.target.value);
        console.log(e.target.value, "sssssssssssss");

        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: "bi bi-pencil-square",

      id: "editBtn",
      title: "عرض",
      ShowStatus: false,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteTransferRequestDetails({
                transferRequestDetailsId: e.target.value,
              })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: HandelRoleTransferResult?.iconsDeleteEditTransfer,
      // ShowStatus: true,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        {
          <TransferRequestDetailsForm
            projectModificationRequestsId={projectModificationRequestsId}
            reportId={reportId}
          />
        }
      </div>
    ),
    title: "تفاصبل طلب المناقلة",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [AddTransferRequestDetails]);

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <TransferRequestDetailsForm
          reportId={reportId}
          projectModificationRequestsId={projectModificationRequestsId}
          subObjectivesId={subObjectivesId}
          canEdit="edit"
        />
      </div>
    ),
    title: "تفاصبل طلب المناقلة",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  const SaveData = (statusId) => {
    const formData = new FormData();
    formData.append(
      "JustificationsforTransferBeneficiary",
      justificationsforTransferBeneficiary
    );
    formData.append(
      "JustificationsForTransferEmployee",
      justificationsForTransferEmployee
    );
    formData.append("RequestDetailsStatusId", statusId);
    formData.append(
      "ProjectModificationRequestsId",
      projectModificationRequestsId
    );
    formData.append("RequestAttachment", null);
    formData.append("EmployeeGUID", userInfo.userToken.userGuid);
    formData.append("File", File);

    dispatch(ProcedureForTransferRequest(formData));
  };
  useEffect(() => {
    dispatch(
      GetProjectModificationRequestsById({
        projectModificationRequestsId: projectModificationRequestsId,
      })
    );
  }, [projectModificationRequestsId]);
  console.log(
    ProjectModificationRequests?.requestDetailsStatusId,
    "ProjectModificationRequests"
  );

  useEffect(() => {
    dispatch(
      HandelRoleTransfer({
        projectModificationRequestsId: projectModificationRequestsId,
        userGuid: userInfo.userToken.userGuid,
        location: location == true ? "Manager" : "Submitter",
      })
    );
  }, []);
  // console.log(HandelRoleTransferResult, "ssssssssssssssdwwdwd");

  return (
    <>
      {HandelRoleTransferResult?.lodind ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="تفاصبل طلب المناقلة"
            child={[
              <>
                <TableAHSF
                  culomEdite={culomEdite}
                  uniqueValue={"transferRequestDetailsId"}
                  valueButtonAction={"transferRequestDetailsId"}
                  URL={`api/TransferRequestDetails/GetListTransferRequestDetails`}
                  UrlBody={{
                    projectModificationRequestsId:
                      projectModificationRequestsId,
                  }}
                  staticKeyEdite={staticKeyEdite}
                  accessor={RequestAccessor}
                  titelTable={""}
                  selectRowNumber={true}
                  checkBoksColumName="اختيار"
                  sort={true}
                  pagination={true}
                  AppStatus={true}
                  // tableBtn={!shouldDisableFields}
                  tableBtn={HandelRoleTransferResult?.iconsAddTransfer}
                  sortTable={true}
                  keyNameSort={"dateCreate"}
                  dateKey="dateCreate"
                  dateformat="DD/MM/YYYY h:mm a"
                  arrayNameSort={["applicationNumber"]}
                  search={true}
                  openPopupState={false}
                  DropdownArrayFiltration={[]}
                  DropdownFiltration={false}
                  exportData={true}
                  checkBoks={false}
                  nameColumAction=""
                  total={false}
                  arrayButton={M_ApplicationsBtns}
                  ArrayNameDataColum={[]}
                  columnKeyNameArray={[
                    { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                  ]}
                  PopupOPjectData={PopupOPjectData}
                  popUpTitle={"معلومات الطلب"}
                  popUpBody={
                    <PopupAHSF
                      isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
                      isPopupOpenFunction={
                        popUpBodyOPjectData.isPopupOpenFunction
                      }
                      title={popUpBodyOPjectData.title}
                      componentBody={popUpBodyOPjectData.componentBody}
                      maxWidth={popUpBodyOPjectData.maxWidth}
                      maxHeight={popUpBodyOPjectData.maxHeight}
                    />
                  }
                />
                <JustificationsforTransfer
                  projectModificationRequestsId={projectModificationRequestsId}
                />
                {ProjectModificationRequests ? (
                  <>
                    <div className="ContainerJustificationsforTransferForm">
                      <JustificationsforTransferForm
                        projectModificationRequestsId={
                          projectModificationRequestsId
                        }
                        DisabledFieldTransfer={
                          HandelRoleTransferResult?.disabledFieldTransfer
                        }
                        JustificationsForEmployee={
                          HandelRoleTransferResult?.justificationsForEmployee
                        }
                        JustificationsForSubmitter={
                          HandelRoleTransferResult?.justificationsForSubmitter
                        }
                        AttachedAmendmentRequestTransfer={
                          HandelRoleTransferResult?.attachedAmendmentRequestTransfer
                        }
                        location={location}
                        File={ProjectModificationRequests?.requestAttachment}
                        setJustificationsforTransferBeneficiary={
                          setJustificationsforTransferBeneficiary
                        }
                        setJustificationsForTransferEmployee={
                          setJustificationsForTransferEmployee
                        }
                        setFile={setFile}
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div className="ConainerButtonAHSF">
                  {HandelRoleTransferResult?.approvalTransferRequest ? (
                    <>
                      <ButtonAHSF
                        // onClick={() => {
                        //   SaveData("fcbd9a1d-259d-4006-8b8a-844940bf35a0");
                        // }}
                        onClick={() => {
                          const missingFields = [];
                          console.log(
                            File,
                            "ProjectModificationRequests?.requestAttachment"
                          );

                          if (!File || File.length === 0) {
                            missingFields.push("مرفق طلب التعديل");
                          }

                          // if (
                          //   !justificationsforTransferBeneficiary ||
                          //   justificationsforTransferBeneficiary.trim() === ""
                          // ) {
                          //   missingFields.push("مبررات المناقلة (المستفيد)");
                          // }
                          if (
                            !justificationsForTransferEmployee ||
                            justificationsForTransferEmployee.trim() === ""
                          ) {
                            missingFields.push("مبررات المناقلة (الموظف)");
                          }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
                </ul>
              </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }

                          SaveData("fcbd9a1d-259d-4006-8b8a-844940bf35a0");
                          navigator(
                            `/SRFund/report/EmployeeTransfers/${reportId}`
                          );
                        }}
                        text="الموافقة على طلب المناقلة"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {HandelRoleTransferResult?.returnToEditTransfer ? (
                    <>
                      <ButtonAHSF
                        onClick={() => {
                          const missingFields = [];
                          console.log(
                            File,
                            "ProjectModificationRequests?.requestAttachment"
                          );

                          // if (
                          //   !justificationsforTransferBeneficiary ||
                          //   justificationsforTransferBeneficiary.trim() === ""
                          // ) {
                          //   missingFields.push("مبررات المناقلة (المستفيد)");
                          // }
                          if (
                            !justificationsForTransferEmployee ||
                            justificationsForTransferEmployee.trim() === ""
                          ) {
                            missingFields.push("مبررات المناقلة (الموظف)");
                          }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
                </ul>
              </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          SaveData("8f37e7fd-29dd-4579-9ec2-37b50f4a62e2");
                          navigator(
                            `/SRFund/report/EmployeeTransfers/${reportId}`
                          );
                        }}
                        text="الارجاع للتعديل"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}

                  {HandelRoleTransferResult?.transferRequestRejected ? (
                    <>
                      <ButtonAHSF
                        onClick={() => {
                          const missingFields = [];
                          console.log(
                            File,
                            "ProjectModificationRequests?.requestAttachment"
                          );

                          if (!File || File.length === 0) {
                            missingFields.push("مرفق طلب التعديل");
                          }
                          // if (
                          //   !justificationsForTransferEmployee ||
                          //   justificationsForTransferEmployee.trim() === ""
                          // ) {
                          //   missingFields.push("مبررات المناقلة (الموظف)");
                          // }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
                </ul>
             </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          SaveData("fbf7dffd-be8f-4b1f-8f2d-f73fc0b022a9");
                          navigator(
                            `/SRFund/report/EmployeeTransfers/${reportId}`
                          );
                        }}
                        text="رفض طلب المناقلة"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {HandelRoleTransferResult?.submitTransferRequest ? (
                    <>
                      <ButtonAHSF
                        onClick={() => {
                          const missingFields = [];

                          if (
                            !justificationsforTransferBeneficiary ||
                            justificationsforTransferBeneficiary.trim() === ""
                          ) {
                            missingFields.push("مبررات المناقلة (المستفيد)");
                          }

                          if (missingFields.length > 0) {
                            Swal.fire({
                              title: "الرجاء تعبئة الحقول التالية",
                              html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
                </ul>
             </div>`,
                              icon: "warning",
                              confirmButtonText: "حسناً",
                            });
                            return;
                          }
                          SaveData("762144a1-2932-4f02-b118-dbeac5f53865");

                          dispatch(
                            ChangeStatusByUser({
                              projectModificationRequestsId:
                                projectModificationRequestsId,
                            })
                          );
                          Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تمت التقديم بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                          navigator(`/SRFund/EmployeeTransfers/${reportId}`);
                        }}
                        text="تقديم طلب المناقلة"
                        show={true}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </>,
            ]}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default TransferRequestDetails;
